import { render, staticRenderFns } from "./GruppoView.vue?vue&type=template&id=cf11f5a6"
import script from "./GruppoView.vue?vue&type=script&lang=js"
export * from "./GruppoView.vue?vue&type=script&lang=js"
import style0 from "./GruppoView.vue?vue&type=style&index=0&id=cf11f5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports